export class ExternalLoginModelToken {
    public key: string;
    public provider: string;

    constructor(key: string, provider: string) {
        this.key = key;
        this.provider = provider;
    }
}



// WEBPACK FOOTER //
// ./src/models/account/external.login.token.model.ts